import { Button, Tooltip } from "@mui/material";
import { cn } from "@utils";

const ToolbarItem = ({
  children,
  onClick,
  ariaLabel,
  className,
  isActive,
  disabled,
  tooltip,
}: {
  children: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  ariaLabel: string;
  tooltip?: string;
  className?: string;
  isActive?: boolean;
}) => {
  return (
    <Tooltip title={tooltip}>
      <div aria-label={`container-${ariaLabel}`}>
        <Button
          onClick={onClick}
          aria-label={ariaLabel}
          disableRipple
          disabled={disabled}
          className={cn("toolbar-item", className)}
          sx={{
            width: "fit-content",
            height: "fit-content",
            padding: "0",
            minWidth: "fit-content",
            minHeight: "fit-content",
            "& > svg": {
              border: isActive ? "1px solid black" : "none",
              fill: disabled ? "rgba(0, 0, 0, 0.54)" : "inherit",
            },
            "&:hover": {
              border: "1px solid inherit",
              backgroundColor: "transparent",
            },
          }}
        >
          {children}
        </Button>
      </div>
    </Tooltip>
  );
};

export default ToolbarItem;
